import {Component, OnInit} from '@angular/core';
import {SocketServices} from '../../CoreModule/services/socket.services';
import {reject} from 'lodash';
import {Observable} from 'rxjs';

@Component({
  selector: 'multiples-mallas',
  templateUrl: '../templates/semanas/multiples.mallas.tiendas.template.html',
  styleUrls: ['../styles/multiples.mallas.tiendas.styles.scss']
})
export class MultiplesMallasTiendasComponent implements OnInit {

  dataHorarios: any;

  separador: string = '';
  semCrear: string = '';
  anoCrear: string = '';
  semMod: string = '';
  anoMod: string = '';

  fileHorarios: any;


  public obsSendLogCrear: Observable<any>;

  logsProceso: any[] = [];

  cantActualizadas: number = 0;
  cantCreadas: number = 0;
  cantNoCreadas: number = 0;
  cantSinVentas: number = 0;

  logFinal: string = '';
  bloquearConsulta: boolean = false;
  isPptoXDia: boolean = false;

  constructor(private ss: SocketServices) {
    this.obsSendLogCrear = this.ss.registrarEvento('logMultMallas');
  }

  ngOnInit() {
    this.obsSendLogCrear.subscribe(d => {
      if (d.code != 0) {
        this.logsProceso.push(d);
        switch (d.code) {
          case -1:
            this.cantSinVentas++;
            break;
          case 1:
            this.cantCreadas++;
            break;
          case 2:
            this.cantActualizadas++;
            break;
          case -2:
            this.cantNoCreadas++;
            break;
        }
      } else {
        this.logFinal = d.msg;
        this.bloquearConsulta = false;
      }
    });
  }

  cargarHorarios($event) {
    this.fileHorarios = $event.target;
  }

  devolverTipoLog(tipo: number) {

    switch (tipo) {
      case -1:
        return 'text-warning';

      case 1:
      case 2:
        return 'text-primary';

      case -2:
        return 'text-danger';

    }
  }


  async crearMallas() {
    if (this.separador == '') {
      return;
    }

    if (this.semCrear == '' || this.anoCrear == '' || this.semMod == '' || this.anoMod == '') {
      alert('Debe ingresar todos los datos de la semana');
      return;
    }

    let infoHor;


    try {
      infoHor = await this.procesarHorarios(this.fileHorarios);
    } catch (e) {
      alert('Error procesando el archivo de horarios, revise el formato del archivo');
      return;
    }


    if (confirm(`Desea crear las mallas de la semana ${this.anoCrear}-${this.semCrear} con las ventas de la semana modelo ${this.anoMod}-${this.semMod}`)) {

      this.logsProceso = [];
      this.cantNoCreadas = this.cantCreadas = this.cantActualizadas = this.cantSinVentas = 0;
      this.bloquearConsulta = true;
      this.logFinal = '';

      this.ss.enviarEvento('crearSemanasMultipes', {
        horarios: infoHor,
        semActual: this.semCrear,
        anoAct: this.anoCrear,
        semMod: this.semMod,
        anoMod: this.anoMod,
        esXDia: this.isPptoXDia
      });
    }
  }


  async procesarHorarios(input: any) {
    let datosHorario: any[] = [];

    let reader = new FileReader();

    return new Promise<any>((resolve, reject) => {
      if (input.files.length > 0) {
        reader.readAsText(input.files[0]);

        reader.onload = (data) => {
          let csvData = reader.result;

          let filas = (csvData as string).split('\n');


          for (let i = 2; i < filas.length; i++) {
            if (filas[i] !== '') {
              let dt = filas[i].split(this.separador);

              let horSem: any = {
                tienda: dt[0],
                dias: [],
                semana: ''
              };

              for (let j = 0; j < 7; j++) {
                horSem.dias.push({
                  dia: j,
                  horaInicio: '',
                  horaCierre: ''
                });
              }

              horSem.dias.map((h, i) => {
                let hdi = dt[((i + 1) * 2) - 1];
                let hdc = dt[((i + 1) * 2)];
                h.horaInicio = (hdi != null) ? hdi.replace('\r', '') : '';
                h.horaCierre = (hdc != null) ? hdc.replace('\r', '') : '';
              });

              // falta ingresar la semana
              datosHorario.push(horSem);

            }
          }
          resolve(datosHorario);
        };
      } else
        reject('Archivo en blanco');
    });


  }

  async procesarPresupuestos(input: any) {
    let pptos: any[] = [];

    let reader = new FileReader();

    return new Promise<any>((resolve, reject) => {
      if (input.files.length > 0) {
        reader.readAsText(input.files[0]);

        reader.onload = (data) => {
          let csvData = reader.result;

          let filas = (csvData as string).split('\n');

          for (let i = 1; i < filas.length; i++) {
            let dt = filas[i].split(this.separador);

            if (this.isPptoXDia) {
              pptos.push({
                tienda: dt[0],
                ppto: dt[1],
                fecha1: dt[2],
                fecha2: dt[3].replace('\r', '')
              });
            } else {
              pptos.push({
                tienda: dt[0],
                ppto: dt[1]
              });
            }
          }

          resolve(pptos);
        };
      } else
        reject('Archivo en blanco');
    });


  }


}
